import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';
import ListCases from './cases/ListCases';
import AttorneyCases from './attorney/AttorneyCases';
import { Spinner } from 'react-bootstrap';

function Home() {
  const auth = useAuth();
  const { isAttorney, isLoading: adminLoading } = useAdmin();

  // Show nothing while auth is loading to prevent flash
  if (auth.isLoading) {
    return null;
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
        <h1>Welcome to Case Trail</h1>
        <p className="mb-4">Please log in to continue</p>
        <button 
          className="btn btn-primary"
          onClick={() => auth.signinRedirect()}
        >
          Log In
        </button>
      </div>
    );
  }

  // Wait for admin context to load role information
  if (adminLoading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Loading...</p>
      </div>
    );
  }

  // Redirect attorneys to their portal
  if (isAttorney) {
    return <Navigate to="/attorney" replace />;
  }

  // Regular users see the cases list
  return <ListCases />;
}

export default Home; 